"use strict";

exports.__esModule = true;
exports.BuildStatus = void 0;
let BuildStatus;
exports.BuildStatus = BuildStatus;
(function (BuildStatus) {
  BuildStatus["SUCCESS"] = "SUCCESS";
  BuildStatus["UP_TO_DATE"] = "UPTODATE";
  BuildStatus["ERROR"] = "ERROR";
  BuildStatus["BUILDING"] = "BUILDING";
  BuildStatus["QUEUED"] = "QUEUED";
  BuildStatus["UPLOADING"] = "UPLOADING";
  BuildStatus["GIT_CLONE"] = "GIT_CLONE";
  BuildStatus["GIT_CLONE_ERROR"] = "GIT_CLONE_ERROR";
  BuildStatus["GIT_PULL"] = "GIT_PULL";
  BuildStatus["GIT_PULL_ERROR"] = "GIT_PULL_ERROR";
  BuildStatus["DEP_INSTALL"] = "DEP_INSTALL";
  BuildStatus["DEP_INSTALL_ERROR"] = "DEP_INSTALL_ERROR";
  BuildStatus["CANCELED"] = "CANCELED";
  BuildStatus["CANCELED_BY_GATSBY_CLOUD"] = "CANCELED_BY_GATSBY_CLOUD";
  BuildStatus["PUBLISHING"] = "PUBLISHING";
  BuildStatus["UPLOAD_ERROR"] = "UPLOAD_ERROR";
  BuildStatus["PUBLISH_ERROR"] = "PUBLISH_ERROR";
  BuildStatus["PUBLISH_CANCELED"] = "PUBLISH_CANCELED";
  BuildStatus["TIMED_OUT"] = "TIMED_OUT";
})(BuildStatus || (exports.BuildStatus = BuildStatus = {}));